<template>
    <div>
        <SubHeader subHeaderTitle="Datos Principales"></SubHeader>

        <v-row>
            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Nit</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.nit}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Nombre Comercial</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.nombre_Comercial}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6">Nombre Fiscal</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.nombre_Fiscal}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Oficina CEO</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.oficinaCeo}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
        </v-row>

        <v-row>
            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Pais</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.pais}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>

            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Departamento</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.depto}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>

            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Municipio</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.municipio}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>

                       
        </v-row>

        <v-row>
            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Dirección</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.direccion}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            
            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Tipo de empresa</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.tipo_Empresa}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>

            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Telefono</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.telefono}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>

             
        </v-row>

        <v-row>
            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Cantidad de trabajadores</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.numero_Personas}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>

            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Tipo de Socios</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.tipoSocio}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>

            <v-col md="4" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Sub tipo de Socios</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.subTipoSocio}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            
        </v-row>
         
        <v-row>
            <v-col md="6" sm="6" xs="12" class="pt-1 pb-1">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 text-uppercase">Asesor Responsable</v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-1">{{datos.asesorResponsable}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
        
            
        </v-row>

        <SubHeader subHeaderTitle="Contactos"></SubHeader>
         <v-row>
            <v-col md="12" sm="12" xs="12" class="pt-1 pb-1">
                <v-data-table
                    :headers="contactoHeaders"
                    :items="contactos"
                    :items-per-page="10"
                    class="elevation-1"
                    no-data-text="No hay contactos registrados..."
                ></v-data-table>
            </v-col>
         </v-row>

        <SubHeader subHeaderTitle="Documentos Legales"></SubHeader>
        <v-row>
            <v-col md="12" sm="12" xs="12" class="pt-1 pb-1">

                <v-data-table
                    :headers="documentosHeaders"
                    :items="documentosLegales"
                    :items-per-page="10"
                    class="elevation-1"
                    no-data-text="No hay documentos registrados..."
                >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.tipo_Documento }}</td>
                            <td> <v-btn
                                    color="primary"
                                    small
                                    :href="item.path" target="_blank">
                                    Descargar
                                </v-btn> </td>
                        </tr>
                    </template>
                
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import SubHeader from "@/view/components/subheader/SubHeader";
export default {
    props:{
        datos: [],
        contactos:[],
        documentosLegales: []
    },
    components:{
        SubHeader
    },
    mounted(){
        console.log(Math.floor(Math.random() * (10 - 1 + 1)) + 1)
    },
    computed:{
         contactoHeaders(){
            return [
                {
                    text: 'Nombre del contacto',
                    align: 'start',
                    sortable: true,
                    value: 'nombre_Completo',
                },
                { text: 'Correo', value: 'email' },
                { text: 'Teléfono', value: 'telefono' },
            ]
        },
        documentosHeaders(){
            return [
                 {
                    text: "Id",
                    align: "start",
                    sortable: false,
                    value: "id"
                },
                 {
                    text: "Tipo documento",
                    align: "start",
                    sortable: true,
                    value: "nombre"
                },
                 {
                    text: "Acciones",
                    align: "start",
                    sortable: false,
                    value: "acciones"
                },

            ]
        },
    }
}
</script>
<style lang="">
    
</style>